//import AsyncStorage from '@react-native-community/async-storage';
//import auth from '@react-native-firebase/auth';
//import database from '@react-native-firebase/database';
import {api} from "hooks/axios"
import store from '../configureStore';
import {SET_BOOK, } from "../actions/actionTypes"
import { setAssets } from "./assets";

//const UUID = require("uuid-v4");



export const getBook = (id) => {
    return((dispatch)=>{
        //console.log("b")
        const promise = new Promise(async(resolve,reject)=>{
            try {
                const book = await api.get('books/'+id)
                //console.log(book.data)
                if(Object.keys(book.data).length!==0){
                    dispatch(setBook(book.data[0]));
                //console.log(books)
                resolve(book);
                }
            } catch(e) {
                console.log(e)
            }
        })
        return promise
        .then(val=>{
            if(val){
                //dispatch(setUser(val))
                //console.log(val)
                return val
                //return (val)

            }
            
        })

    })
}

export const getBookHistory = (bookId,month,year) => {
    return((dispatch)=>{
        //console.log("b")
        const promise = new Promise(async(resolve,reject)=>{
            try {
                const book = await api.post('bookHistory/get_book_history/bookId='+bookId+'&month='+month+'&year='+year)
                //console.log(book.data)
                //if(Object.keys(book.data).length!==0){
                    dispatch(setAssets(book.data))
                //console.log(books)
                resolve(book);
                //}
            } catch(e) {
                console.log(e)
            }
        })
        return promise
        .then(val=>{
            if(val){
                //dispatch(setUser(val))
                //console.log(val)
                return val
                //return (val)

            }
            
        })

    })
}

export const getBooksAccess = (id) => {
    return((dispatch)=>{
        //console.log("b")
        const promise = new Promise(async(resolve,reject)=>{
            try {
                const book = await api.get('access/'+id)
                //console.log(book.data)
                if(Object.keys(book.data).length!==0){
                    dispatch(setBook(book.data));
                //console.log(book)
                resolve(book);
                }
            } catch(e) {
                console.log(e)
            }
        })
        return promise
        .then(val=>{
            if(val){
                //dispatch(setBook(val))
                //console.log(val)
                return val
                //return (val)

            }
            
        })

    })
}

export const createBook = async (data) => {
    return((dispatch)=>{
        //console.log("b")
        const promise = new Promise(async(resolve,reject)=>{
            try {
                const response = await api.post('books', {
                    name: data.name,
                    desc: data.desc,
                    role:1,
                    status:1,
                    user_id:data.user_id, 
                    
                })
                console.log(response)
            } catch(e) {
                console.log(e)
            }
        })
        return promise
        .then(val=>{
            if(val){
                dispatch(getBook(data.id))
                //console.log(val)
                return val
                //return (val)

            }
            
        })

    })
}

export const updateBook = (data) => {
    return((dispatch)=>{
        //console.log(data)
        const promise = new Promise(async(resolve,reject)=>{
            try {
                const response = await api.post('books/update/'+data.bookId, {
                    name: data.name,
                    desc: data.desc,
                })
                if(response.status==="200"||response.status==="201"){
                    //props.handleClose()
                    resolve(true)
                }else{
                    resolve(false)
                }
                }catch(e){
                    console.log(e)
                }
        })
        return promise
        .then(val=>{
            if(val){
                dispatch(getBooksAccess(data.user_id))
                //console.log(val)
                return val
            }
        })
    })
}

export const updateBookHistory = (data) => {
    return((dispatch)=>{
        
        var state = store.getState()
        const promise = new Promise(async(resolve,reject)=>{
            try {
                const response = await api.post('bookHistory', {
                    data: JSON.stringify(data.history),
                    
                })
                if(response.status==="200"||response.status==="201"){
                    //props.handleClose()
                    resolve(true)
                }
                //console.log(response)
            } catch(e) {
                console.log(e)
            }
        })
        return promise
        .then(val=>{
            if(val){
                var data=[]
                data.id = state.books.book_id
                data.month = new Date()
                dispatch(updateBookMonth(data))
                //console.log(val)
                return val
                //return (val)

            }
            
        })

    })
}

export const updateBookAmount = (data) => {
    return((dispatch)=>{
        
        var state = store.getState()
        //console.log(state)
        var data =[]

        for (let key in state.assets) {    
            //console.log(state.assets[key])  
            var temp={}
            temp["asset_id"]=state.assets[key]["asset_id"]
            temp["amount"]=state.assets[key]["amount"]
            data.push(temp)
            //console.log(data.length)
        }
        //console.log(data)
        //console.log(JSON.stringify(data))
        const promise = new Promise(async(resolve,reject)=>{
            try {
                //console.log(state)
                const response = await api.post('books/updateAmount', {
                    data: JSON.stringify(data),
                    
                })
                if(response.status==="200"||response.status==="201"){
                    //props.handleClose()
                    resolve(true)
                }
                //console.log(response)
            } catch(e) {
                console.log(e)
            }
        })
        return promise
        .then(val=>{
            if(val){
                var data=[]
                data.id = state.books.book_id
                data.month = new Date()
                dispatch(updateBookMonth(data))
                //console.log(val)
                return val
                //return (val)

            }
            
        })

    })
}

export const updateBookMonth = (data) => {
    return((dispatch)=>{
        //console.log("b")
        const promise = new Promise(async(resolve,reject)=>{
            try {
                const response = await api.post('books/update/'+data.id, {
                    active_month: data.month,
                })
                console.log(response)
                //console.log(response.data.messages['bookId'])
                //localStorage.setItem("bookId",this.props.id)
                //this.setState({navigate:"/"})
            
            } catch(e) {
                console.log(e)
            }
        })
        return promise
        .then(val=>{
            if(val){
                dispatch(getBook(data.id))
                //console.log(val)
                return val
                //return (val)

            }
            
        })

    })
}


export const setBook = (item) => {
    //AsyncStorage.setItem("grow:auth:user",user.uid);
    //console.log(user)
    //addUser(user)
    //console.log(item)
    return{
        type: SET_BOOK,
        item: item,
    }
}